(() => {
  if (window.dartsrxJudgeMeReviewsBound) return;
  window.dartsrxJudgeMeReviewsBound = true;

  const sectionSelector = '[data-dartsrx-judgeme-section]';
  const widgetSelector =
    '#judgeme_product_reviews, .jdgm-review-widget, .jdgm-all-reviews-widget, .jdgm-carousel-wrapper';
  const reviewSelector = '.jdgm-rev, .jdgm-carousel-item';
  const judgeMeEndpoint = 'https://api.judge.me/reviews/reviews_for_widget';
  const reviewImageSelector = '.jdgm-rev__pic-link, .jdgm-rev__pic-link img, .jdgm-rev__pic-img';

  const getWidget = (root) => root.querySelector(widgetSelector);
  const getReviews = (root) => [...root.querySelectorAll(reviewSelector)];
  const getPagination = (section) => section.querySelector('.jdgm-paginate');
  const writeButtonSelector =
    '.jdgm-write-rev-link, .jdgm-widget-actions-wrapper, .jdgm-btn--border, [data-judgeme-write-review]';

  const getReviewKey = (review) =>
    review.id ||
    review.getAttribute('data-review-id') ||
    review.getAttribute('data-id') ||
    review.textContent.trim().replace(/\s+/g, ' ').slice(0, 260);

  const getImageSource = (element) => {
    const link = element.matches?.('.jdgm-rev__pic-link') ? element : element.closest?.('.jdgm-rev__pic-link');
    const img = element.matches?.('img') ? element : element.querySelector?.('img');

    return (
      img?.getAttribute('data-src') ||
      img?.getAttribute('data-original') ||
      img?.getAttribute('data-url') ||
      img?.dataset?.src ||
      img?.dataset?.original ||
      img?.dataset?.url ||
      link?.getAttribute('data-mfp-src') ||
      link?.getAttribute('data-src') ||
      link?.getAttribute('href') ||
      ''
    );
  };

  const hydrateMedia = (root = document) => {
    root.querySelectorAll('.jdgm-rev__pic-link').forEach((link) => {
      const source = getImageSource(link);
      link.classList.remove('jdgm--loading');
      link.removeAttribute('style');

      if (source && !link.getAttribute('href')) {
        link.setAttribute('href', source);
      }

      if (source) {
        link.setAttribute('data-dartsrx-review-image', source);
        link.setAttribute('role', 'button');
      }

      if (source && !link.querySelector('img')) {
        const image = document.createElement('img');
        image.className = 'jdgm-rev__pic-img';
        image.alt = 'Customer review photo';
        image.src = source;
        link.appendChild(image);
      }
    });

    root.querySelectorAll('.jdgm-rev__pic-link img, .jdgm-rev__pic-img, .dartsrx-judgeme-reviews img').forEach((img) => {
      const source = getImageSource(img);
      const current = img.getAttribute('src') || '';

      if (source && (!current || current === '#' || current.startsWith('data:image'))) {
        img.setAttribute('src', source);
      }

      if (source) {
        img.closest('.jdgm-rev__pic-link')?.setAttribute('data-dartsrx-review-image', source);
      }

      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');

      const loadingParent = img.closest('.jdgm--loading');
      if (loadingParent) loadingParent.classList.remove('jdgm--loading');
    });
  };

  const getRatingValue = (review) => {
    const ratingNode = review.querySelector('[data-score], [data-rating], .jdgm-rev__rating, .jdgm-carousel-item__review-rating');
    const rawValue =
      ratingNode?.getAttribute('data-score') ||
      ratingNode?.getAttribute('data-rating') ||
      ratingNode?.getAttribute('aria-label') ||
      '';
    const parsed = Number(String(rawValue).match(/\d+(\.\d+)?/)?.[0] || 0);
    const starCount = review.querySelectorAll('.jdgm-star.jdgm--on, .jdgm-star.jdgm--half').length;
    const value = parsed || starCount || 5;

    return Math.max(1, Math.min(5, Math.round(value)));
  };

  const hydrateStars = (root = document) => {
    const reviews = root.matches?.(reviewSelector) ? [root] : getReviews(root);

    reviews.forEach((review) => {
      if (review.querySelector('.dartsrx-judgeme-stars')) return;

      const rating = getRatingValue(review);
      const stars = document.createElement('span');
      stars.className = 'dartsrx-judgeme-stars';
      stars.setAttribute('aria-label', `${rating} out of 5 stars`);
      stars.textContent = '★★★★★';

      const target =
        review.querySelector('.jdgm-rev__header') ||
        review.querySelector('.jdgm-carousel-item__review') ||
        review.firstElementChild ||
        review;
      target.prepend(stars);
    });
  };

  const removeWriteButtons = (root = document) => {
    root.querySelectorAll(writeButtonSelector).forEach((button) => button.remove());
  };

  const getReviewLightbox = () => {
    let lightbox = document.querySelector('[data-dartsrx-review-lightbox]');

    if (lightbox) return lightbox;

    lightbox = document.createElement('div');
    lightbox.className = 'dartsrx-judgeme-lightbox';
    lightbox.setAttribute('data-dartsrx-review-lightbox', '');
    lightbox.hidden = true;
    lightbox.innerHTML = `
      <button class="dartsrx-judgeme-lightbox__backdrop" type="button" data-dartsrx-review-lightbox-close>
        <span class="visually-hidden">Close review image</span>
      </button>
      <div class="dartsrx-judgeme-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Review image" tabindex="-1">
        <button class="dartsrx-judgeme-lightbox__close" type="button" data-dartsrx-review-lightbox-close>
          <span aria-hidden="true">×</span>
          <span class="visually-hidden">Close review image</span>
        </button>
        <img class="dartsrx-judgeme-lightbox__image" alt="Customer review photo">
      </div>
    `;
    document.body.appendChild(lightbox);

    return lightbox;
  };

  const closeReviewLightbox = () => {
    const lightbox = document.querySelector('[data-dartsrx-review-lightbox]');
    if (!lightbox || lightbox.hidden) return;

    lightbox.hidden = true;
    lightbox.classList.remove('is-open');
    document.documentElement.classList.remove('dartsrx-judgeme-lightbox-open');
    document.body.classList.remove('dartsrx-judgeme-lightbox-open');
  };

  const openReviewLightbox = (source) => {
    if (!source) return;

    const lightbox = getReviewLightbox();
    const image = lightbox.querySelector('.dartsrx-judgeme-lightbox__image');
    const dialog = lightbox.querySelector('.dartsrx-judgeme-lightbox__dialog');

    image.src = source;
    lightbox.hidden = false;
    lightbox.classList.add('is-open');
    document.documentElement.classList.add('dartsrx-judgeme-lightbox-open');
    document.body.classList.add('dartsrx-judgeme-lightbox-open');
    dialog?.focus();
  };

  const getInsertionPoint = (widget) =>
    widget?.querySelector('.jdgm-rev-widg__reviews') ||
    widget?.querySelector('.jdgm-rev-widg__body') ||
    widget?.querySelector('.jdgm-all-reviews__body') ||
    widget;

  const getTotalReviews = (section) => {
    const totalNode = section.querySelector('[data-number-of-reviews]');
    const total = Number(totalNode?.getAttribute('data-number-of-reviews') || section.dataset.totalReviews || 0);
    return Number.isFinite(total) ? total : 0;
  };

  const getCurrentPage = (section) => {
    const nativeCurrent = Number(getPagination(section)?.querySelector('.jdgm-curt[data-page]')?.getAttribute('data-page') || 0);
    const storedCurrent = Number(section.dataset.currentPage || 1);
    return nativeCurrent || storedCurrent || 1;
  };

  const getNextPage = (section) => {
    const pagination = getPagination(section);
    const current = getCurrentPage(section);
    if (!pagination) return current + 1;

    const nativeNext = Number(pagination.querySelector('.jdgm-paginate__next-page[data-page]')?.getAttribute('data-page') || 0);
    if (nativeNext > current) return nativeNext;

    const nextPage = [...pagination.querySelectorAll('.jdgm-paginate__page[data-page]')]
      .filter((link) => !link.classList.contains('jdgm-paginate__last-page'))
      .map((link) => Number(link.getAttribute('data-page') || 0))
      .filter((page) => page > current)
      .sort((a, b) => a - b)[0];

    return nextPage || 0;
  };

  const updateLoadButton = (section) => {
    const button = section.querySelector('[data-dartsrx-reviews-load]');
    if (!button) return;

    const widget = getWidget(section);
    const total = getTotalReviews(section);
    const reviewCount = widget ? getReviews(widget).length : 0;
    const hasMore = Boolean(getNextPage(section)) || Boolean(total && reviewCount < total);

    section.dataset.totalReviews = total ? String(total) : section.dataset.totalReviews || '';
    section.dataset.currentPage = String(getCurrentPage(section));

    button.hidden = !hasMore;
    button.textContent = 'Load more reviews';
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
  };

  const parseFetchedReviews = (html) => {
    const parser = new DOMParser();
    const documentFragment = parser.parseFromString(html || '', 'text/html');

    return {
      reviews: getReviews(documentFragment),
      pagination: documentFragment.querySelector('.jdgm-paginate'),
    };
  };

  const buildReviewsUrl = (section, page) => {
    const pagination = getPagination(section);
    const url = new URL(pagination?.dataset?.url || judgeMeEndpoint);
    const perPage = section.dataset.perPage || pagination?.dataset?.perPage || '5';

    url.searchParams.set('shop_domain', section.dataset.shopDomain || window.Shopify?.shop || window.location.hostname);
    url.searchParams.set('platform', 'shopify');
    url.searchParams.set('per_page', perPage);
    url.searchParams.set('page', String(page));

    if (section.dataset.productId) {
      url.searchParams.set('product_id', section.dataset.productId);
    }

    return url.toString();
  };

  const replacePagination = (section, nextPagination) => {
    const currentPagination = getPagination(section);
    if (!nextPagination) return;

    if (currentPagination) {
      currentPagination.replaceWith(nextPagination);
      return;
    }

    const widget = getWidget(section);
    widget?.appendChild(nextPagination);
  };

  const appendFetchedPage = async (section) => {
    if (typeof window.fetch !== 'function') {
      throw new Error('Review loading is not available in this browser.');
    }

    const widget = getWidget(section);
    const insertionPoint = getInsertionPoint(widget);
    if (!widget || !insertionPoint) return 0;

    const page = getNextPage(section);
    if (!page) return 0;

    const existingKeys = new Set(getReviews(widget).map(getReviewKey));
    const response = await window.fetch(buildReviewsUrl(section, page), {
      credentials: 'omit',
      mode: 'cors',
    });

    if (!response.ok) {
      throw new Error(`Judge.me returned ${response.status}.`);
    }

    const data = await response.json();
    const { reviews, pagination } = parseFetchedReviews(data.html);
    const newReviews = reviews.filter((review) => !existingKeys.has(getReviewKey(review)));

    newReviews.forEach((review) => {
      const imported = review.cloneNode(true);
      hydrateMedia(imported);
      hydrateStars(imported);
      removeWriteButtons(imported);
      insertionPoint.appendChild(imported);
    });

    replacePagination(section, pagination);
    section.dataset.currentPage = String(Number(data.page || page));
    section.dataset.totalReviews = String(Number(data.total_count || section.dataset.totalReviews || 0));

    hydrateMedia(section);
    hydrateStars(section);
    removeWriteButtons(section);
    updateLoadButton(section);

    return newReviews.length;
  };

  const clickNativeNextPage = async (section) => {
    const widget = getWidget(section);
    const pagination = getPagination(section);
    if (!widget || !pagination) return 0;

    const existingKeys = new Set(getReviews(widget).map(getReviewKey));
    const current = getCurrentPage(section);
    const nextLink =
      pagination.querySelector('.jdgm-paginate__next-page') ||
      [...pagination.querySelectorAll('.jdgm-paginate__page[data-page]')]
        .filter((link) => !link.classList.contains('jdgm-paginate__last-page'))
        .find((link) => Number(link.getAttribute('data-page') || 0) > current);

    if (!nextLink) return 0;

    nextLink.hidden = false;
    nextLink.removeAttribute('hidden');
    nextLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    nextLink.click?.();

    await delay(900);
    hydrateMedia(section);
    hydrateStars(section);
    removeWriteButtons(section);
    updateLoadButton(section);

    return getReviews(widget).filter((review) => !existingKeys.has(getReviewKey(review))).length;
  };

  const initialiseSection = (section) => {
    removeWriteButtons(section);
    hydrateMedia(section);
    hydrateStars(section);
    updateLoadButton(section);
  };

  const delay = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

  const waitForElement = async (root, selector, timeout = 1800) => {
    const start = Date.now();
    let element = root.querySelector(selector);

    while (!element && Date.now() - start < timeout) {
      await delay(80);
      element = root.querySelector(selector);
    }

    return element;
  };

  const writeTriggerSelector = [
    '.jdgm-rev-widg__summary .jdgm-write-rev-link',
    '.jdgm-write-rev-link',
    '.jdgm-widget-actions-wrapper .jdgm-write-rev-link',
    '.jdgm-widget-actions-wrapper button',
    '.jdgm-widget-actions-wrapper [role="button"]',
    '.jdgm-btn--border',
    '.jdgm-widget-actions-wrapper a',
    '[data-judgeme-write-review]',
  ].join(', ');

  const writeFormSelector = '.jdgm-form-wrapper, .jdgm-rev-widg__form, .jdgm-form';

  const getJudgeMe = () => window.jdgm || window.JDGM || null;

  const loadJudgeMeWidgets = () => {
    try {
      getJudgeMe()?.loadWidgets?.();
    } catch (error) {
      console.warn(error);
    }
  };

  const callJudgeMeWriter = (section) => {
    const judgeMe = getJudgeMe();
    if (!judgeMe) return false;

    const productId = section.dataset.productId;
    const attempts = [
      { owner: judgeMe, name: 'openReviewForm', args: productId ? [productId] : [] },
      { owner: judgeMe, name: 'writeReview', args: productId ? [productId] : [] },
      { owner: judgeMe, name: 'showReviewForm', args: productId ? [productId] : [] },
      { owner: judgeMe.reviewWidget, name: 'openForm', args: productId ? [productId] : [] },
      { owner: judgeMe.shopify, name: 'openReviewForm', args: productId ? [productId] : [] },
    ];

    return attempts.some((attempt) => {
      if (typeof attempt.owner?.[attempt.name] !== 'function') return false;

      try {
        attempt.owner[attempt.name](...attempt.args);
        return true;
      } catch (error) {
        console.warn(error);
        return false;
      }
    });
  };

  const revealWriteForm = (section) => {
    const form = section.querySelector(writeFormSelector) || document.querySelector(writeFormSelector);
    if (!form) return false;

    section.classList.add('dartsrx-judgeme-reviews--writing');
    form.classList.add('dartsrx-judgeme-native-form');
    form.hidden = false;
    form.removeAttribute('aria-hidden');
    form.style.removeProperty('display');
    form.style.removeProperty('visibility');
    form.style.removeProperty('opacity');
    form.style.removeProperty('height');
    form.style.removeProperty('max-height');

    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const firstField = form.querySelector('input:not([type="hidden"]), textarea, select, button');
    firstField?.focus?.({ preventScroll: true });

    return true;
  };

  const openWriteReview = async (section) => {
    section.classList.add('dartsrx-judgeme-reviews--writing');
    loadJudgeMeWidgets();

    if (callJudgeMeWriter(section)) {
      await delay(240);
      if (revealWriteForm(section)) return;
    }

    let trigger = section.querySelector(writeTriggerSelector) || document.querySelector(writeTriggerSelector);
    if (!trigger) trigger = await waitForElement(section, writeTriggerSelector);
    if (!trigger) trigger = await waitForElement(document, writeTriggerSelector);

    if (trigger) {
      trigger.removeAttribute('hidden');
      trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      trigger.click?.();
      await delay(160);

      if (revealWriteForm(section)) {
        return;
      }
    }

    let form = await waitForElement(section, writeFormSelector, 1200);
    if (!form) form = await waitForElement(document, writeFormSelector, 1200);
    if (form && revealWriteForm(section)) {
      return;
    }

    const widget = getWidget(section);
    widget?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const initialise = (root = document) => {
    root.querySelectorAll(sectionSelector).forEach(initialiseSection);
  };

  let mediaObserverQueued = false;

  const queueHydrateMedia = () => {
    if (mediaObserverQueued) return;
    mediaObserverQueued = true;
    requestAnimationFrame(() => {
      mediaObserverQueued = false;
      hydrateMedia(document);
      hydrateStars(document);
      removeWriteButtons(document);
      document.querySelectorAll(sectionSelector).forEach(updateLoadButton);
    });
  };

  const observer = new MutationObserver(queueHydrateMedia);

  const observeSections = (root = document) => {
    const sections = root.matches?.(sectionSelector)
      ? [root]
      : [...root.querySelectorAll(sectionSelector)];

    sections.forEach((section) => {
      if (section.dataset.dartsrxJudgeMeObserved === 'true') return;
      section.dataset.dartsrxJudgeMeObserved = 'true';
      observer.observe(section, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'data-src', 'data-mfp-src'],
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initialise(document);
    observeSections(document);
  });
  document.addEventListener('shopify:section:load', (event) => {
    initialise(event.target);
    observeSections(event.target);
  });
  initialise(document);
  observeSections(document);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeReviewLightbox();
  });

  document.addEventListener('click', async (event) => {
    const lightboxClose = event.target.closest('[data-dartsrx-review-lightbox-close]');
    if (lightboxClose) {
      event.preventDefault();
      closeReviewLightbox();
      return;
    }

    const reviewImage = event.target.closest(reviewImageSelector);
    const reviewImageLink = reviewImage?.closest?.('.jdgm-rev__pic-link');
    if (reviewImageLink) {
      const source = reviewImageLink.getAttribute('data-dartsrx-review-image') || getImageSource(reviewImageLink);
      if (source) {
        event.preventDefault();
        event.stopPropagation();
        openReviewLightbox(source);
        return;
      }
    }

    const writeButton = event.target.closest('[data-dartsrx-reviews-write]');
    if (writeButton) {
      event.preventDefault();
      const section = writeButton.closest(sectionSelector);
      if (section) await openWriteReview(section);
      return;
    }

    const button = event.target.closest('[data-dartsrx-reviews-load]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const section = button.closest(sectionSelector);
    if (!section || button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Loading reviews...';

    try {
      let added = 0;

      try {
        added = await appendFetchedPage(section);
      } catch (error) {
        console.warn(error);
      }

      if (!added) {
        added = await clickNativeNextPage(section);
      }

      if (!added) throw new Error('Judge.me did not return another review page.');
    } catch (error) {
      console.error(error);
      button.textContent = 'Try again';
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  });
})();
